import { useEffect, useState } from 'react';
import { fetchChart } from '../lib/api';

export function useChart(symbol, range = '1y', interval = '1d') {
  const [bars, setBars] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!symbol) return;
    let cancelled = false;
    setLoading(true);
    fetchChart(symbol, range, interval)
      .then((res) => { if (!cancelled) setBars(res.bars); })
      .catch((e) => { if (!cancelled) setError(e.message); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [symbol, range, interval]);

  return { bars, error, loading };
}
